// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fd-j";
export var fulfillmentFormRail = "_fd-i";
export var headerTitleRow = "_fd-l";
export var orderDetailsWrapper = "_fd-g";
export var orderLinkTrigger = "_fd-2";
export var paymentInformationGrid = "_fd-q";
export var paymentSummaryColumn = "_fd-r";
export var phoneShipmentPickerButton = "_fd-e";
export var phoneShipmentPickerButtonContent = "_fd-f";
export var phoneShipmentPickerButtonWrapper = "_fd-d";
export var phoneShipmentPickerTrigger = "_fd-c";
export var shipmentContainer = "_fd-k";
export var shipmentDetailsMainPane = "_fd-h";
export var shipmentNavigationCard = "_fd-a";
export var shipmentNavigationEdgeTrigger = "_fd-6";
export var shipmentNavigationRail = "_fd-3";
export var shipmentNavigationRailEnter = "_fd-5";
export var shipmentNavigationRailHeader = "_fd-9";
export var shipmentNavigationRailOverlay = "_fd-4";
export var shipmentNavigationScrim = "_fd-7";
export var shipmentSummaryFact = "_fd-n";
export var shipmentSummaryGrid = "_fd-m";
export var shipmentSummaryMetadataRow = "_fd-o";
export var shipmentSummaryTags = "_fd-p";
export var shipmentWorkspace = "_fd-0";
export var shipmentWorkspaceBodyTablet = "_fd-8";
export var shipmentWorkspaceContent = "_fd-b";
export var shipmentWorkspaceHeader = "_fd-1";